import { pushEventToGTMDataLayer } from 'application/gtm_utils'

export function formEvent(data) {
  const dataEvent = {
    event: data.event,
    form_name: data.form_name,
    form_type: data.form_type,
    form_page: data.form_page
  }

  if (data.form_step) {
    dataEvent.form_step = data.form_step
    dataEvent.event_detail = data.event_detail
  }

  if (data.event == "form_field_change") {
    dataEvent.field_name = data.field_name
  }

  pushEventToGTMDataLayer(dataEvent);
}

/**
 * Extracts form_name, form_type, form_page from the form data attributes
 * @param {JQuery} $form form
 * @returns {Object} data for GA event
 */
export function commonGaEventFormData($form) {
  return {
    form_name: $form.data('formName'),
    form_type: $form.data('formType') || $form.data('formName'),
    form_page: document.title
  }
}

export function formFieldChangeEvent(data) {
  const dataEvent = {
    event: data.event,
    form_name: data.form_name,
    form_type: data.form_type,
    form_page: data.form_page,
    field_name: data.field_name,
    field_value: data.field_value,
    field_type: data.field_type
  }

  if (data.form_step) {
    dataEvent.form_step = data.form_step
  }

  pushEventToGTMDataLayer(dataEvent);
}
